export default "__VITE_ASSET__A$UBDhzr__"